import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { detectWebDeviceType } from "../../utils";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const UOMInputDropdown = ({ uomOptions, selectedValue, onChange }) => {
    const { t, i18n } = useTranslation();
  
    const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const deviceType = detectWebDeviceType();

  const selectedLabel =
    uomOptions.find((item) => item.uom_id === selectedValue)?.uom_name || "";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative  w-full" ref={dropdownRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center mt-2 justify-between px-4 py-2 border border-[#ccc] rounded-lg cursor-pointer bg-white text-sm"
        style={{
          minHeight: deviceType === "tablet" ? 54 : 36,
        }}
      >
        <span className=" w-fullt text-xl text-body font-normal">{t(selectedLabel) || t("Select")}</span>
        <FaChevronDown className="text-gray-600" />
      </div>

      {open && (
        <div
          className="absolute left-0 right-0 bg-white shadow-lg border rounded-lg mt-1 z-50 max-h-60 overflow-y-auto"
          style={{ fontSize: deviceType === "tablet" ? 16 : 14 }}
        >
          {uomOptions.map((item) => (
            <div
              key={item.uom_id}
              onClick={() => {
                onChange(item.uom_id);
                setOpen(false);
              }}
              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                selectedValue === item.uom_id ? "bg-gray-100 font-medium" : ""
              }`}
            >
              {t(item.uom_name)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UOMInputDropdown;
